<template>
    <router-view />
</template>

<script>
export default {
    name: 'CoRouterBase',
};
</script>
